import React from "react"
import { Icon } from "@/components"
import * as styles from "./index.module.scss"

interface IRenderItemProps {
  checked: boolean
  option: Option
  disabled?: boolean
  onClick: React.MouseEventHandler<HTMLDivElement>
}

const RenderItem = ({ checked, option, onClick }: IRenderItemProps) => (
  <div className={styles.renderItem} onClick={onClick}>
    <span>{option.label}</span>
    {checked && <Icon name={"check"} />}
  </div>
)

export default RenderItem
